/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as Char123LocaleChar125RouteImport } from './routes/{-$locale}'
import { Route as Char123LocaleChar125IndexRouteImport } from './routes/{-$locale}/index'
import { Route as Char123LocaleChar125WidgetRouteImport } from './routes/{-$locale}/widget'
import { Route as Char123LocaleChar125TermsAndConditionsFullRouteImport } from './routes/{-$locale}/terms-and-conditions-full'
import { Route as Char123LocaleChar125TermsAndConditionsRouteImport } from './routes/{-$locale}/terms-and-conditions'
import { Route as Char123LocaleChar125PrivacyPolicyRouteImport } from './routes/{-$locale}/privacy-policy'
import { Route as Char123LocaleChar125ContactRouteImport } from './routes/{-$locale}/contact'
import { Route as Char123LocaleChar125BusinessRouteImport } from './routes/{-$locale}/business'

const Char123LocaleChar125Route = Char123LocaleChar125RouteImport.update({
  id: '/{-$locale}',
  path: '/{-$locale}',
  getParentRoute: () => rootRouteImport,
} as any)
const Char123LocaleChar125IndexRoute =
  Char123LocaleChar125IndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => Char123LocaleChar125Route,
  } as any)
const Char123LocaleChar125WidgetRoute =
  Char123LocaleChar125WidgetRouteImport.update({
    id: '/widget',
    path: '/widget',
    getParentRoute: () => Char123LocaleChar125Route,
  } as any)
const Char123LocaleChar125TermsAndConditionsFullRoute =
  Char123LocaleChar125TermsAndConditionsFullRouteImport.update({
    id: '/terms-and-conditions-full',
    path: '/terms-and-conditions-full',
    getParentRoute: () => Char123LocaleChar125Route,
  } as any)
const Char123LocaleChar125TermsAndConditionsRoute =
  Char123LocaleChar125TermsAndConditionsRouteImport.update({
    id: '/terms-and-conditions',
    path: '/terms-and-conditions',
    getParentRoute: () => Char123LocaleChar125Route,
  } as any)
const Char123LocaleChar125PrivacyPolicyRoute =
  Char123LocaleChar125PrivacyPolicyRouteImport.update({
    id: '/privacy-policy',
    path: '/privacy-policy',
    getParentRoute: () => Char123LocaleChar125Route,
  } as any)
const Char123LocaleChar125ContactRoute =
  Char123LocaleChar125ContactRouteImport.update({
    id: '/contact',
    path: '/contact',
    getParentRoute: () => Char123LocaleChar125Route,
  } as any)
const Char123LocaleChar125BusinessRoute =
  Char123LocaleChar125BusinessRouteImport.update({
    id: '/business',
    path: '/business',
    getParentRoute: () => Char123LocaleChar125Route,
  } as any)

export interface FileRoutesByFullPath {
  '/{-$locale}': typeof Char123LocaleChar125RouteWithChildren
  '/{-$locale}/business': typeof Char123LocaleChar125BusinessRoute
  '/{-$locale}/contact': typeof Char123LocaleChar125ContactRoute
  '/{-$locale}/privacy-policy': typeof Char123LocaleChar125PrivacyPolicyRoute
  '/{-$locale}/terms-and-conditions': typeof Char123LocaleChar125TermsAndConditionsRoute
  '/{-$locale}/terms-and-conditions-full': typeof Char123LocaleChar125TermsAndConditionsFullRoute
  '/{-$locale}/widget': typeof Char123LocaleChar125WidgetRoute
  '/{-$locale}/': typeof Char123LocaleChar125IndexRoute
}
export interface FileRoutesByTo {
  '/{-$locale}/business': typeof Char123LocaleChar125BusinessRoute
  '/{-$locale}/contact': typeof Char123LocaleChar125ContactRoute
  '/{-$locale}/privacy-policy': typeof Char123LocaleChar125PrivacyPolicyRoute
  '/{-$locale}/terms-and-conditions': typeof Char123LocaleChar125TermsAndConditionsRoute
  '/{-$locale}/terms-and-conditions-full': typeof Char123LocaleChar125TermsAndConditionsFullRoute
  '/{-$locale}/widget': typeof Char123LocaleChar125WidgetRoute
  '/{-$locale}': typeof Char123LocaleChar125IndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/{-$locale}': typeof Char123LocaleChar125RouteWithChildren
  '/{-$locale}/business': typeof Char123LocaleChar125BusinessRoute
  '/{-$locale}/contact': typeof Char123LocaleChar125ContactRoute
  '/{-$locale}/privacy-policy': typeof Char123LocaleChar125PrivacyPolicyRoute
  '/{-$locale}/terms-and-conditions': typeof Char123LocaleChar125TermsAndConditionsRoute
  '/{-$locale}/terms-and-conditions-full': typeof Char123LocaleChar125TermsAndConditionsFullRoute
  '/{-$locale}/widget': typeof Char123LocaleChar125WidgetRoute
  '/{-$locale}/': typeof Char123LocaleChar125IndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/{-$locale}'
    | '/{-$locale}/business'
    | '/{-$locale}/contact'
    | '/{-$locale}/privacy-policy'
    | '/{-$locale}/terms-and-conditions'
    | '/{-$locale}/terms-and-conditions-full'
    | '/{-$locale}/widget'
    | '/{-$locale}/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/{-$locale}/business'
    | '/{-$locale}/contact'
    | '/{-$locale}/privacy-policy'
    | '/{-$locale}/terms-and-conditions'
    | '/{-$locale}/terms-and-conditions-full'
    | '/{-$locale}/widget'
    | '/{-$locale}'
  id:
    | '__root__'
    | '/{-$locale}'
    | '/{-$locale}/business'
    | '/{-$locale}/contact'
    | '/{-$locale}/privacy-policy'
    | '/{-$locale}/terms-and-conditions'
    | '/{-$locale}/terms-and-conditions-full'
    | '/{-$locale}/widget'
    | '/{-$locale}/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  Char123LocaleChar125Route: typeof Char123LocaleChar125RouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/{-$locale}': {
      id: '/{-$locale}'
      path: '/{-$locale}'
      fullPath: '/{-$locale}'
      preLoaderRoute: typeof Char123LocaleChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/{-$locale}/': {
      id: '/{-$locale}/'
      path: '/'
      fullPath: '/{-$locale}/'
      preLoaderRoute: typeof Char123LocaleChar125IndexRouteImport
      parentRoute: typeof Char123LocaleChar125Route
    }
    '/{-$locale}/widget': {
      id: '/{-$locale}/widget'
      path: '/widget'
      fullPath: '/{-$locale}/widget'
      preLoaderRoute: typeof Char123LocaleChar125WidgetRouteImport
      parentRoute: typeof Char123LocaleChar125Route
    }
    '/{-$locale}/terms-and-conditions-full': {
      id: '/{-$locale}/terms-and-conditions-full'
      path: '/terms-and-conditions-full'
      fullPath: '/{-$locale}/terms-and-conditions-full'
      preLoaderRoute: typeof Char123LocaleChar125TermsAndConditionsFullRouteImport
      parentRoute: typeof Char123LocaleChar125Route
    }
    '/{-$locale}/terms-and-conditions': {
      id: '/{-$locale}/terms-and-conditions'
      path: '/terms-and-conditions'
      fullPath: '/{-$locale}/terms-and-conditions'
      preLoaderRoute: typeof Char123LocaleChar125TermsAndConditionsRouteImport
      parentRoute: typeof Char123LocaleChar125Route
    }
    '/{-$locale}/privacy-policy': {
      id: '/{-$locale}/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/{-$locale}/privacy-policy'
      preLoaderRoute: typeof Char123LocaleChar125PrivacyPolicyRouteImport
      parentRoute: typeof Char123LocaleChar125Route
    }
    '/{-$locale}/contact': {
      id: '/{-$locale}/contact'
      path: '/contact'
      fullPath: '/{-$locale}/contact'
      preLoaderRoute: typeof Char123LocaleChar125ContactRouteImport
      parentRoute: typeof Char123LocaleChar125Route
    }
    '/{-$locale}/business': {
      id: '/{-$locale}/business'
      path: '/business'
      fullPath: '/{-$locale}/business'
      preLoaderRoute: typeof Char123LocaleChar125BusinessRouteImport
      parentRoute: typeof Char123LocaleChar125Route
    }
  }
}

interface Char123LocaleChar125RouteChildren {
  Char123LocaleChar125BusinessRoute: typeof Char123LocaleChar125BusinessRoute
  Char123LocaleChar125ContactRoute: typeof Char123LocaleChar125ContactRoute
  Char123LocaleChar125PrivacyPolicyRoute: typeof Char123LocaleChar125PrivacyPolicyRoute
  Char123LocaleChar125TermsAndConditionsRoute: typeof Char123LocaleChar125TermsAndConditionsRoute
  Char123LocaleChar125TermsAndConditionsFullRoute: typeof Char123LocaleChar125TermsAndConditionsFullRoute
  Char123LocaleChar125WidgetRoute: typeof Char123LocaleChar125WidgetRoute
  Char123LocaleChar125IndexRoute: typeof Char123LocaleChar125IndexRoute
}

const Char123LocaleChar125RouteChildren: Char123LocaleChar125RouteChildren = {
  Char123LocaleChar125BusinessRoute: Char123LocaleChar125BusinessRoute,
  Char123LocaleChar125ContactRoute: Char123LocaleChar125ContactRoute,
  Char123LocaleChar125PrivacyPolicyRoute:
    Char123LocaleChar125PrivacyPolicyRoute,
  Char123LocaleChar125TermsAndConditionsRoute:
    Char123LocaleChar125TermsAndConditionsRoute,
  Char123LocaleChar125TermsAndConditionsFullRoute:
    Char123LocaleChar125TermsAndConditionsFullRoute,
  Char123LocaleChar125WidgetRoute: Char123LocaleChar125WidgetRoute,
  Char123LocaleChar125IndexRoute: Char123LocaleChar125IndexRoute,
}

const Char123LocaleChar125RouteWithChildren =
  Char123LocaleChar125Route._addFileChildren(Char123LocaleChar125RouteChildren)

const rootRouteChildren: RootRouteChildren = {
  Char123LocaleChar125Route: Char123LocaleChar125RouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
